import { Stack, Typography } from '@mui/material';
import { useCampaignCreationStore } from '../stores/useCampaignCreationStore';
import { formatDateFromNow } from 'utils/datetime';
import { Button } from 'system/atoms';
import { useState } from 'react';
import { useEffect } from 'react';
import { launchButtonsSx } from '../styles';

type Props = {
  handleNext: () => void;
  isLoading?: boolean;
  isError?: boolean;
  errorTitle?: string;
  errorMessage?: string;
  children?: React.ReactNode;
};

export const CampaignCreationNextButton: React.FC<Props> = ({
  handleNext,
  isLoading,
  children
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [renderCount, setRenderCount] = useState(0);
  const campaignLastUpdatedAt = useCampaignCreationStore(
    (store) => store.campaignLastUpdatedAt
  );

  // Rerender for the Draft last saved to be updated
  useEffect(() => {
    if (!campaignLastUpdatedAt) {
      return;
    }

    const interval = setInterval(() => {
      setRenderCount((prev) => prev + 1);
    }, 30000);
    return () => clearInterval(interval);
  }, [campaignLastUpdatedAt]);

  return (
    <>
      <Stack
        direction="row"
        justifyContent="flex-start"
        gap="15px"
        alignItems="center"
      >
        <Button
          variant="primary"
          onClick={() => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
            handleNext();
          }}
          disabled={isLoading}
          loading={isLoading}
        >
          Next step
        </Button>
        {children}
        {campaignLastUpdatedAt && (
          <Typography variant="body2" sx={launchButtonsSx.savedText}>
            Draft last saved{' '}
            {formatDateFromNow(campaignLastUpdatedAt.toISOString())}
          </Typography>
        )}
      </Stack>
    </>
  );
};
